import { Ship, Users, Heart, PartyPopper, Compass, Building2 } from "lucide-react";
import { IMAGES } from "@/lib/images";
import { SectionHeading, FeatureGrid, CTABand } from "@/components/PageBlocks";
import { PageHero } from "@/components/PageBlocks";
import { useSeo } from "@/hooks/useSeo";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const TYPES = [
  { icon: Ship, title: "Ocean Cruises", desc: "Classic sailings to popular regions, with a ship and itinerary matched to you." },
  { icon: Users, title: "Group Cruises", desc: "Sailing with a crowd? We help coordinate cabins and keep everyone together." },
  { icon: Users, title: "Family & Friends Cruises", desc: "Something for every age, from cabins to shore days and dining." },
  { icon: PartyPopper, title: "Celebration Cruises", desc: "Mark a birthday, anniversary, or reunion at sea." },
  { icon: Heart, title: "Couples & Honeymoon Cruises", desc: "Quieter ships and romantic itineraries for two." },
  { icon: Compass, title: "Choosing the Right Ship & Itinerary", desc: "We compare the options so you don't have to research it all alone." },
];

const HELP = [
  { icon: Compass, title: "Trip Discovery", desc: "We start with what you want the trip to feel like, then suggest cruise lines and regions that fit." },
  { icon: Ship, title: "Itinerary Comparisons", desc: "We compare routes, ports, and sailing lengths so the days line up with your interests." },
  { icon: Building2, title: "Cabin Considerations", desc: "We help you weigh cabin types, locations, and what's worth it for your trip." },
];

export default function Cruises() {
  useSeo({ title: "Cruises, Made Simple | Inforno Travel", description: "Inforno Travel helps you compare ships, itineraries, and cabins to find the right cruise — for couples, families, groups, and celebrations." });
  return (
    <div className="bg-noir min-h-screen">
      <Navbar />
      <PageHero overline="Cruises" title="Cruising, Made Simple." image={IMAGES.cruise}
        sub="There are a lot of ships, routes, and cabin choices out there. We help you sort through them so you don't have to research everything alone — and end up on the sailing that's right for you."
        primary={{ label: "Start Planning Your Cruise", to: "/start-your-journey" }} />

      <section className="py-24 md:py-32 px-6 md:px-12 bg-noir">
        <div className="max-w-[1500px] mx-auto">
          <div className="mb-14"><SectionHeading overline="Ways to Cruise" title="Find your kind of sailing" /></div>
          <FeatureGrid items={TYPES} />
        </div>
      </section>

      <section className="py-24 md:py-32 px-6 md:px-12 bg-[#0a0a0a] border-y border-white/10">
        <div className="max-w-[1500px] mx-auto">
          <div className="mb-14"><SectionHeading overline="How Inforno Helps" title="From first idea to setting sail" /></div>
          <FeatureGrid items={HELP} />
          <p className="font-body text-white/40 text-xs mt-8 max-w-2xl font-light">Pricing and availability are confirmed during planning with your Travel Experience Specialist.</p>
        </div>
      </section>

      <CTABand eyebrow="Ready to sail?" title="Let's find the right cruise for you." label="Start Planning Your Cruise" to="/start-your-journey" showRtb />
      <Footer />
    </div>
  );
}
